import { FC, useEffect, useRef } from 'react'
import { SearchQA } from 'shared/dataAttributes'
import { renderUntil } from 'shared/hocs/render'
import shave from 'shave'
import styled, { css } from 'styled-components'
import GridItemName from './GridItemName'

const MOBILE_NAME_HEIGHT = 55
const OPTIMIZED_MOBILE_NAME_HEIGHT = 42

const GridName = styled(GridItemName)<{ isOptimizedPLP?: boolean }>`
  ${({ isOptimizedPLP }) =>
    isOptimizedPLP
      ? css`
          font-size: 12px;
          line-height: 120%;
          height: ${OPTIMIZED_MOBILE_NAME_HEIGHT}px;
        `
      : css`
          height: ${MOBILE_NAME_HEIGHT}px;
        `};
  text-overflow: ellipsis;
  word-wrap: normal;
`

interface IMobileGridNameProps {
  name: string
  className?: string
  isOptimizedPLP?: boolean
}

const MobileGridName: FC<IMobileGridNameProps> = ({ name, isOptimizedPLP }) => {
  const gridNameEl = useRef(null)
  useEffect(() => {
    shave(gridNameEl.current, MOBILE_NAME_HEIGHT, { spaces: false })
  }, [name])
  return (
    <GridName ref={gridNameEl} data-qa={SearchQA.ProductItemTitle} isOptimizedPLP={isOptimizedPLP}>
      {name}
    </GridName>
  )
}

MobileGridName.displayName = 'MobileGridName'

export default renderUntil.large(MobileGridName)
